module.exports = __webpack_public_path__ + "static/media/besties-stack-fr.d9930cc1.png";